<template>
  <div class="container">
    <div style="margin-bottom: 5em;"></div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="jumbotron" style="margin: auto;">
          <h1 class="display-3">{{$sysName}}</h1>
          <p class="lead">APIファーストでデザインされたシステムのクライアントサイドを高速開発するためのフレームワークです。</p>
          <hr class="my-4">
          <p>言語はJavascript、利用しているフレームワークはVue.jsです。スタイルシートにはUMIを使用しています。</p>
          <button class="btn-lg btn-primary" @click="miiafwlibs_alert('工事中です！<br/>誰か作って！')"><font-awesome-icon icon="info-circle" />&nbsp;もっと詳しく</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/**
  * @module views/TopPage
  * @description バトンタッチプラットフォームのトップ画面
**/

export default {
  name: 'TopPage',
  data () {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
